import menuIcon from "../../../assets/menuIcon.png";
import payments from "../../../assets/payments.png";
import deleteIcon from "../../../assets/deletePic.png";
import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";

function RemovePayment() {
  const { t } = useTranslation();

  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I remove a payment account?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.General.removePayments.step1.part1")}
          <img src={menuIcon} alt="icon" className="inline-flex" />{" "}
          {t("helpCenter.General.removePayments.step1.part2")}
          <img src={payments} alt="icon" className="inline-flex h-7 w-7" />{" "}
          {t("helpCenter.General.removePayments.step1.part3")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.General.removePayments.step2.part1")}
          <img src={deleteIcon} alt="icon" className="inline-flex" />{" "}
          {t("helpCenter.General.removePayments.step2.part2")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.General.removePayments.step3")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.General.removePayments.step4")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default RemovePayment;
